import { Injectable } from '@angular/core';
import { StoreData } from '@shared/module/common/model/store-data';
import { Observable } from 'rxjs/Observable';
import { LemsarApiClient } from '@lemsar/api/client';
import { UI } from '@shared/models/ui';
import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { Collection } from '@lemsar/common/domains/interface/collection';
import { Document } from '@lemsar/institution/domains/model/document';

@Injectable()
export class DocumentService {
    private _ui: StoreData<UI>;

    public constructor(private api: LemsarApiClient) {
        this._ui = new StoreData<UI>(new UI());
    }

    public get ui$(): Observable<UI> {
        return this._ui.stream$;
    }

    public get ui(): UI {
        return this._ui.value;
    }

    public fetchInstitutionDocuments(params?: any): Observable<Collection<Document>> {
        const queryParams = !params ? { page: 1, limit: 20 } : { page: params.page || 1, limit: params.limit || 20 };

        return this.api.get<any>(`documents`, queryParams).pipe(ResponseTransformer.toCollection(Document));
    }

    public fetchInstitutionDocument(id: string): Observable<Document> {
        return this.api.get<any>(`documents/${id}`).pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Document));
    }

    public createInstitutionDocument(value: Document): Observable<Document> {
        return this.api.post<any>(`documents`, value).pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Document));
    }

    public updateInstitutionDocument(id: string, value: Document): Observable<Document> {
        return this.api
            .patch<any>(`documents/${id}`, value)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Document));
    }

    public deleteInstitutionDocument(id: string): Observable<Document> {
        return this.api.delete<any>(`documents/${id}`).pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Document));
    }

    public fetchPreWorkDocuments(): Observable<Collection<Document>> {
        return this.api.get<any>('pre-work-card-documents').pipe(ResponseTransformer.toCollection(Document));
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/services/document.service.ts